import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

/**
 * Admin API client — uses httpOnly cookies for auth.
 * Session cookie is set by the backend on login.
 */
const adminApi = axios.create({
  baseURL: BACKEND_URL,
  withCredentials: true,
});

export default adminApi;
